<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">{{PageTitle}}</div>
                <button type="button" v-on:click.prevent="onBackClick()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <form id="benefitForm">
                    <div class="row">
                        <!--View Update Uploads Section-->
                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3>
                                        View/Update Details
                                        <button id="view" type="button" class="btn btn-primary pull-right"><i class="fa fa-eye" aria-hidden="true"></i></button>
                                        <button id="edit" type="button" class="btn btn-primary pull-right"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                    </h3>
                                </div>
                                <div class="card-body">

                                    <!--Update Detail Section-->
                                    <div id="editDetails" class="editDetails">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="locationId">State<span class="text-danger">*</span></label>
                                                <v-select v-model="locationId"
                                                          multiple
                                                          @change="changedValue"
                                                          @input="changedValueLocation()"
                                                          name="locationId"
                                                          id="locationId"
                                                          label="text"
                                                          :filterable="false"
                                                          :options="locationArr"
                                                          @search="onSearchLocation"
                                                          placeholder="Select State">
                                                    <template slot="no-options">
                                                        Search State...
                                                    </template>
                                                    <template slot="option" slot-scope="option">
                                                        <div class="d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                    <template slot="selected-option" slot-scope="option">
                                                        <div class="selected d-center">
                                                            {{ option.text }}
                                                        </div>
                                                    </template>
                                                </v-select>
                                                <font class="text-danger">{{locationError}}</font>
                                            </div>
                                        </div>

                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="roleData">HR<span class="text-danger">*</span></label>
                                                <v-select class=""
                                                          v-model="hrId"
                                                          name="hrId"
                                                          id="roleData"
                                                          label="name"
                                                          @input="changedValueRole()"
                                                          :searchable="false"
                                                          :filterable="false"
                                                          :options="hr_managerArr"
                                                          placeholder="Select Role">
                                                </v-select>
                                                <font class="text-danger">{{roleError}}</font>
                                            </div>
                                        </div>

                                        <!--Title-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="form-group">
                                                <label for="description">Title<span class="text-danger">*</span></label>
                                                <input v-model="title" type="text" class="form-control" id="title" placeholder="Title" />
                                                <font class="text-danger">{{titleError}}</font>
                                            </div>
                                        </div>

                                        <!--Redirection Link-->
                                        <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">-->
                                        <!--<div class="form-group">-->
                                        <!--<label for="redirectionLink">Redirection Link</label>-->
                                        <!--<input v-model="redirectionLink" type="text" class="form-control" id="redirectionLink" placeholder="Redirection Link" />-->
                                        <!--<font class="text-danger">{{redirectionLinkError}}</font>-->
                                        <!--</div>-->
                                        <!--</div>        -->

                                        <!--Contact Email-->
                                        <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="contactEmail">Contact Email</label>
                                                <input v-model="contactEmail" type="text" class="form-control" id="contactEmail" placeholder="Contact Email" />
                                                <font class="text-danger">{{contactEmailError}}</font>
                                            </div>
                                        </div>-->

                                        <!--Contact Numbar-->
                                        <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="contactNumber">Contact Number</label>
                                                <input v-model="contactNumber" type="text" class="form-control" id="contactNumber" placeholder="Contact Number" />
                                                <font class="text-danger">{{contactNumberError}}</font>
                                            </div>
                                        </div>-->

                                        <!--Image-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <template>
                                                <div id="app">
                                                    <label for="drop1">Upload Image<span class="text-danger">*</span></label>
                                                    <vue-dropzone
                                                        id="drop1"
                                                        :options="dropzoneOptions"
                                                        ref="dropzone"
                                                        :destroyDropzone="false"
                                                        :headers="dropzoneOptions.headers"
                                                        @vdropzone-removed-file="removedSelectedFile"
                                                        @vdropzone-success="vfileSuccess"
                                                        @vdropzone-duplicate-file="vduplicateFile"
                                                        @vdropzone-total-upload-progress="progressOfUloadImg"
                                                        name="file"
                                                        >
                                                    </vue-dropzone>
                                                    <font class="text-danger">{{imageError}}</font>
                                                    <font class="text-danger"> <strong id="errorMsg2" class="error text-danger"></strong></font>
                                                </div>
                                            </template>
                                        </div>

                                        <!-- Description-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="description">Description</label>
                                                <!--<textarea id="txtEditor" ref="signdata" v-model="description" name="description"></textarea>-->
                                                <tinymce :plugins="['advlist autolink lists link image charmap print preview hr anchor pagebreak', 'searchreplace wordcount visualblocks visualchars code fullscreen', 'insertdatetime media nonbreaking save table contextmenu directionality','template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample']" id="description" v-model="description" class= "" ref="tm" :other_options="options"></tinymce>
                                                <font class="text-danger">{{descriptionError}}</font>
                                            </div>
                                        </div>


                                        <!--Error Alert-->
                                        <div class=" clearfix" >
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="alert alert-danger" id="alertError">
                                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                    <strong id="errorMsg" class="error"></strong>
                                                </div>
                                            </div>
                                        </div>

                                        <!--Buttons-->
                                        <div class=" clearfix"></div>
                                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="button-demo">
                                                <input id="addBenifitBtn" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdatePoliciesForms()">
                                                <input id="addAndContinueBenifitBtn" type="submit" value="Save and Continue" class="btn btn-primary" v-on:click.prevent="addUpdatePoliciesForms(flag='Save and Continue')">
                                                <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdatePoliciesForms()"></input>-->
                                                <input id="CancelBenifit" type="submit" value="Cancel" class="btn btn-primary" v-on:click.prevent="buttonCancleEdit()">
                                            </div>
                                        </div>
                                    </div>
                                    <!--End Update Detail Section-->

                                    <!--View Detail Section-->
                                    <div id="viewDetail" class="viewDetails">
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="locationId">State<span class="text-danger">*</span></label>
                                                <span class="form-control" >
                                                    <p v-for="(locations, index) in locationId" style="float: left;">
                                                        {{locations.text}} &nbsp;
                                                    </p>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="roleData">HR<span class="text-danger">*</span></label>
                                                <span class="form-control" >{{hrDisplayName}}</span>
                                            </div>
                                        </div>

                                        <!--Title-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="description">Title<span class="text-danger">*</span></label>
                                                <span class="form-control" >{{title}}</span>
                                            </div>
                                        </div>

                                        <!--Redirection Link-->
                                        <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">-->
                                        <!--<div class="form-group">-->
                                        <!--<label for="redirectionLink">Redirection Link</label>-->
                                        <!--<span class="form-control" >{{redirectionLink}}</span>-->
                                        <!--</div>-->
                                        <!--</div>-->

                                        <!--Contact Email-->
                                        <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="contactEmail">Contact Email</label>
                                                <span class="form-control" >{{contactEmail}}</span>
                                            </div>
                                        </div>-->

                                        <!--Contact Numbar-->
                                        <!--<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="contactNumber">Contact Number</label>
                                                <span class="form-control" >{{contactNumber}}</span>
                                            </div>
                                        </div>-->

                                        <!--Image-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <template>
                                                <div id="app">
                                                    <label for="drop1">Uploaded Image<span class="text-danger">*</span></label><br/>
                                                    <img :src="imageDisplayWhileView" height="200px" width="200px">
                                                    <!--<img v-bind:src="imagePath" height="200px" width="200px">-->

                                                    <!--<vue-dropzone-->
                                                    <!--id="drop1"-->
                                                    <!--:options="dropzoneOptions"-->
                                                    <!--ref="dropzone"-->
                                                    <!--:destroyDropzone="false"-->
                                                    <!--:headers="dropzoneOptions.headers"-->
                                                    <!--@vdropzone-removed-file="removedSelectedFile"-->
                                                    <!--@vdropzone-success="vfileSuccess"-->
                                                    <!--@vdropzone-duplicate-file="vduplicateFile"-->
                                                    <!--name="file"-->
                                                    <!--&gt;-->
                                                    <!--</vue-dropzone>-->
                                                </div>
                                            </template>
                                        </div>

                                        <!-- Description-->
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-group">
                                            <div class="form-group">
                                                <label for="description">Description</label>
                                                <p v-html="description" class=""></p>
                                            </div>
                                        </div>

                                    </div>
                                    <!--End View Detail Section-->
                                    <div class="clearfix"></div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3>
                                        Upload Docs
                                        <button id="showDocListBtn" type="button" class="btn btn-primary pull-right"><i class="fa fa-eye" aria-hidden="true"></i></button>
                                        <button id="addDocBtn" type="button" class="btn btn-primary pull-right"><i class="fa fa-plus" aria-hidden="true"></i></button>
                                    </h3>
                                </div>
                                <div class="card-body">

                                    <!--Upload Docs Section-->
                                    <div id="policiesFormsDocsDiv" class="policiesFormsDocsDiv">
                                        <div id="myRadioGroup">
                                            <!--Button Title-->
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="form-group">
                                                    <label for="buttonTitle">Button Title</label>
                                                    <input v-model="buttonTitle" type="text" class="form-control" id="buttonTitle" placeholder="Button Title" />
                                                    <font class="text-danger">{{buttonTitleError}}</font>
                                                </div>
                                            </div>
                                            <div style="display: none;" class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <span id="myForm">
                                                    <!--<label><input id="uploadManually" type="radio" name="cars" value="2"/>Upload Docs</label>-->
                                                    <label><input id="vodepUrl" type="radio" name="cars" value="3" checked="checked">Enter URL</label>
                                                </span>
                                            </div>
                                            <br/>
                                            <br/>


                                            <!--Upload Docs-->
                                            <div style="display: none;" id="Cars2" class="desc">
                                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <template>
                                                        <div id="dropzone">
                                                            <vue-dropzone
                                                                id="drop1"
                                                                :options="dropzoneOptionsDocFile"
                                                                ref="dropzoneDocFile"
                                                                :destroyDropzone="false"
                                                                :headers="dropzoneOptionsDocFile.headers"
                                                                @vdropzone-removed-file="removedSelectedDocFile"
                                                                @vdropzone-success="vDocfileSuccess"
                                                                @vdropzone-total-upload-progress="progressOfUload"
                                                                name="file"
                                                                >
                                                            </vue-dropzone>
                                                            <font class="text-danger"> {{docUploadError}}</font>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>

                                            <!--Enter Button URL-->
                                            <div class="clearfix"></div>
                                            <div div id="Cars3" class="desc" >
                                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                    <div class="form-group">
                                                        <label for="buttonURL">Button URL</label>
                                                        <input v-model="buttonURL" type="text" class="form-control" id="buttonURL" placeholder="Button URL">
                                                        <font class="text-danger">{{buttonURLError}}</font>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!--Error Alert-->
                                        <div class=" clearfix" >
                                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div class="alert alert-danger" id="alertErrorDoc">
                                                    <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                                    <strong id="errorMsgDoc" class="error"></strong>
                                                </div>
                                            </div>
                                        </div>

                                        <div class=" clearfix" ></div>
                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="button-demo">
                                                <button id="savePoliciesFormsDocs" type="button" class="btn btn-primary" v-on:click="saveUploadedDoc()">Save</button>
                                                <button id="cancleDocUpload" type="button" class="btn btn-primary" v-on:click="onCancleUpload()">Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                    <!--End Upload Doc Section-->

                                    <!--List Doc Section-->

                                    <div id="listPoliciesFormsDocsDiv" class="listPoliciesFormsDocsDiv">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="form-group">
                                                <label for="buttonTitle">Uploaded Doc List</label>
                                                <div class="form-line">
                                                    <ul>
                                                        <draggable v-model="policiesFormDocList" v-on:change="changeButtonPosition()" class="drag-view">
                                                            <template v-for="(text, index) in policiesFormDocList">
                                                                <li>
                                                                    <button title='Delete Doc' id="deleteDoc" class="mb-1 btn btn-primary"  v-on:click.prevent="deleteDoc(text.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                                                    <!--<template v-if="text.button_document != ''">-->
                                                                    <!--<button title='Archive Doc' id="archivesDoc" class="mb-1 btn btn-primary"  v-on:click.prevent="archivesDoc(text.id)"><i class="fa fa-archive" aria-hidden="true"></i></button>-->
                                                                    <!--<a :href="text.button_document" target="_blank"> {{text.button_title}}</a>-->
                                                                    <!--</template>-->
                                                                    <template v-if="text.button_url != ''">
                                                                        <a :href="text.button_url" target="_blank"> {{text.button_title}}</a>
                                                                    </template>
                                                                </li>
                                                            </template>
                                                        </draggable>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <!--End List Doc Section-->
                                    <div class="clearfix"></div>

                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>


<script>
    var self;
    import vSelect from 'vue-select';
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import draggable from 'vuedraggable';
    import tinymce from 'vue-tinymce-editor';

    export default {
        name: 'Login',
        props: [''],
        mixins: [SessioMixin],
        components: {
            'v-select': vSelect,
            vueDropzone: vue2Dropzone,
            'tinymce': tinymce,
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                options: {
                    /*language_url: 'http://example.com/js/langs/fa_IR.js' //This url points to location of persian language file.*/
                },
                //DropZone
                dropzoneOptions: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 50, //MB
                    maxFiles: 1, //ToDo : to decide number of files allowed
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    duplicateCheck: true,
                    acceptedFiles: ".jpg, .jpeg",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only {{maxFiles}} file is allowed",
                    dictDefaultMessage: "Drop files here to upload",
                },

                //DropZone For Doc Upload
                dropzoneOptionsDocFile: {
                    timeout: 3000000,
                    url: process.env.ROOT_API + "/uploadmedia",
                    method: 'POST',
                    paramName: 'file',
                    autoProcessQueue: true,
                    maxFilesize: 150, //MB
                    maxFiles: 1,
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    acceptedFiles: ".pdf, .doc, .docx",
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        // 'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
                        // 'Access-Control-Allow-Headers': 'Content-Type, Authorization, X-Requested-With',//'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
                        //'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    dictFileTooBig: "File is too big ({{filesize}}mb). Max allowed file size is {{maxFilesize}}mb",
                    dictInvalidFileType: "Invalid File Type",
                    dictCancelUpload: "Cancel",
                    dictRemoveFile: "Remove",
                    dictMaxFilesExceeded: "Only 1 file is allowed",
                    dictDefaultMessage: "Drop file here to upload",
                },

                imageType: [],
                imageSize: [],
                imagePath: [],
                imageWidth: 0,
                imageHeight: 0,
//                V-model
                locationId: '',
                locationArr: [],
                hrId: 0,
                hrDisplayName: '',
                hr_managerArr: [],
                title: '',
                redirectionLink: '',
                contactEmail: '',
                contactNumber: '',
                description: '',
                PageTitle: 'View/Update ERG',
                imageDisplayWhileView: '',

                buttonTitle: '',
                buttonURL: '',
                isDocUploaded: false,
                policiesFormDocList: [],

//                FrontEnd Errors
                titleError: '',
                redirectionLinkError: '',
                contactEmailError: '',
                contactNumberError: '',
                descriptionError: '',
                roleError: '',
                locationError: '',
                imageError: '',
                isFileUploaded: false,

                buttonTitleError: '',
                buttonURLError: '',
                docUploadError: '',
                docPaths: '',
                docTypes: '',
                selectedRadioButton: 3,

//                BackEnd Error
                backendErrors: [],
            }
        },
        mounted: function () {
            self = this;
            self.checkLogin();
            self.loadLocationsAdd();
            self.getHrAndManagers();
            self.loadLocations();
            self.loadSurveyDocs();

            // View Update Details
            self.initialConditions();
            self.selectedRadioButton = 3;
            $("#view").click(function () {
                self.onClickViewDetails();
            });
            $("#edit").click(function () {
                self.onClickEditDetails();
            });
            // End View Update Details

            // List Upload Docs
            self.IntialConditionForDocUpload();
            $("#showDocListBtn").click(function () {
                self.addDocListViewClick();
            });
            $("#addDocBtn").click(function () {
                self.addDocClick();
            });
            // End List Upload Docs

            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[2] == 'viewupdateerg') {
                if (segments[3]) {
                    self.loadPoliciesAndForms();
                    $("#addAndContinueBenifitBtn").hide();
                    $("#addBenifitBtn").val("Update");
                    // self.pageTitle = "Edit Policies And Forms";
                }
            } else {
                self.selectedRadioButton = 3;
            }

            $(document).ready(function () {
                $("input[name$='cars']").click(function () {
                    var test = $(this).val();

                    $("div.desc").hide();
                    $("#Cars" + test).show();
                    // self.buttonTitle = "";
                    self.buttonURLError = "";
                    self.buttonTitleError = "";
                });
            });

            $('#myForm input').on('change', function () {
                var selectedRadioButton = $('input[name=cars]:checked', '#myForm').val();
                self.selectedRadioButton = selectedRadioButton;
                if (self.selectedRadioButton == 3) {
                    self.removeAllDocFiles();
                    self.docPaths = '';
                    self.isDocUploaded = true;
                } else if (self.selectedRadioButton == 2) {
                    self.isDocUploaded = false;
                }
            });

            $("#title").on('keyup', function () {
                self.titleError = '';
            });
            $("#locationId").on('keyup', function () {
                self.locationError = '';
            });
            $("#hrId").on('keyup', function () {
                self.roleError = '';
            });
            $("#redirectionLink").on('keyup', function () {
                self.redirectionLinkError = '';
            });
            $("#contactEmail").on('keyup', function () {
                self.contactEmailError = '';
            });
            $("#contactNumber").on('keyup', function () {
                self.contactNumberError = '';
            });
            $("#buttonTitle").on('keyup', function () {
                self.buttonTitleError = '';
            });
            $("#buttonURL").on('keyup', function () {
                self.buttonURLError = '';
            });


            $("#drop1").on('change', function () {
            });

            $("#alertError").hide();
            $("#alertErrorDoc").hide();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/

        },
        watch: {

        },
        methods: {
            getHrAndManagers: function() {
              var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                          except_self : self.userId
                        }
                    };
                    HTTP.get('gethrandmanager', config)
                        .then(function (response) {
                          self.hr_managerArr = response.data.content;
                        }).catch(function (err) {
                            // $('#exportUsers').text('Export');
                            // $('#exportUsers').prop("disabled", false);
                            if (err.response.status == 0) {
                                if (err.response.status == 0) {


                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    self.error = err.response.data.message;
                                }
                            }
                            self.exportUsers = false;
                        });

            },
            changeButtonPosition() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    policiesFormsList: self.policiesFormDocList,
                    id: segments[3],
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changepositionsurveydoc", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            buttonCancleEdit() {
                self.onClickViewDetails();
            },
            onBackClick() {
                self.$router.push('/backend/listerg');
            },
            onCancleUpload() {
                self.addDocListViewClick();
            },
            IntialConditionForDocUpload() {
                $("#showDocListBtn").hide();
                $("#addDocBtn").show();
                $(".policiesFormsDocsDiv").hide();
                $(".listPoliciesFormsDocsDiv").show();
            },
            addDocClick() {
                $("#showDocListBtn").show();
                $("#addDocBtn").hide();
                $(".policiesFormsDocsDiv").show();
                $(".listPoliciesFormsDocsDiv").hide();
            },
            addDocListViewClick() {
                $("#showDocListBtn").hide();
                $("#addDocBtn").show();
                $(".policiesFormsDocsDiv").hide();
                $(".listPoliciesFormsDocsDiv").show();
            },
            deleteDoc(id) {
                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = {mainId: segments[3], mapperId: id, };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post('deletedocforselectedidsurvey', fields, config).
                                then(response => {
                                    self.$swal({
                                        type: 'success',
                                        html: "File Deleted Successfully",
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    self.loadSurveyDocs();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                });
                        self.$swal({
                            title: 'Deleted',
                            type: 'success',
                            html: "You successfully deleted the record(s).",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            html: "Your record(s) still intact",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                });
            },
            archivesDoc(id) {
                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = {mainId: segments[3], mapperId: id, };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Archive it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.post('archivedocforselectedidsurvey', fields, config).
                                then(response => {
                                    self.$swal({
                                        type: 'success',
                                        html: "File Archived Successfully",
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    self.loadSurveyDocs();
                                })
                                .catch(function (err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            self.$router.push("/login");
                                        }
                                        self.error = err.response.data.message;
                                    }
                                });
                        self.$swal({
                            title: 'Archived',
                            type: 'success',
                            html: "You successfully archived the record(s).",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    } else {
                        self.$swal({
                            title: 'Cancelled',
                            type: 'info',
                            html: "Your record(s) still intact",
                            showConfirmButton: false,
                            timer: 5000,
                        });
                    }
                });
            },

            loadSurveyDocs: function () {
                var path = window.location.pathname;
                var segments = path.split("/");

                var fields = {id: segments[3]};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                self.showLoader();
                HTTP.post('loadsurveydocs', fields, config).
                        then(response => {
                            self.policiesFormDocList = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            removeAllDocFiles() {
                self.$refs.dropzoneDocFile.removeAllFiles();
            },
            removedSelectedDocFile(file, xhr, error) {
                if(file && file.xhr && file.xhr.response){
                    self.isDocUploaded = false;
                    self.docPaths = '';
                    self.docTypes = '';
                    var filePath = JSON.parse(file.xhr.response);
                    //console.log(file);
                    if ("media_thumb_path" in filePath.content) {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                    } else {
                        //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                        self.removeFileFromServer(filePath.content.media_path, "");
                    }
                }
            },
            vDocfileSuccess: function (file, response) {
                self.docPaths = response.content.media_path;
                self.isDocUploaded = true;
                self.docUploadError = '';
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.docTypes = file.type;
            },
            checkDocForm: function () {
                var checked = true;
                if (!self.buttonTitle) {
                    self.buttonTitleError = "Button Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.selectedRadioButton == 2) {
                    if (self.isDocUploaded == false) {
                        self.docUploadError = "Please Upload File";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                if (self.selectedRadioButton == 3) {
                    if (!self.buttonURL) {
                        self.buttonURLError = "Please Enter URL";
                        if (checked) {
                            checked = false;
                        }
                    } else if (!self.validUrl(self.buttonURL)) {
                        self.buttonURLError = 'Please Enter Valid URL';
                        if (checked) {
                            checked = false;
                        }
                    }
                }

                return checked;
            },
            validUrl: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },

            saveUploadedDoc() {
                self.checkDocForm();
                if (self.checkDocForm()) {
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    $("#savesavePoliciesFormsDocs").val("Saving ...");
                    $("#savesavePoliciesFormsDocs").prop("disabled", true);
                    var fields = {
                        buttonTitle: self.buttonTitle,
                        docPaths: self.docPaths,
                        docTypes: self.docTypes,
                        buttonURL: self.buttonURL,
                        uploadedType: self.selectedRadioButton,
                        id: segments[3],
                    };
                    self.showLoader();
                    HTTP.post("uploadsurveydocs", fields, config)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    $("#savesavePoliciesFormsDocs").val("Save");
                                    $("#savesavePoliciesFormsDocs").prop("disabled", false);
                                    $("#errorMsgDoc").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    self.loadSurveyDocs();

                                    setTimeout(function () {
                                        self.addDocListViewClick();
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                        self.removeAllDocFiles();
                                        self.buttonTitle = '';
                                        self.buttonURL = '';
                                    }, 5000);
                                } else {
                                    $("#savesavePoliciesFormsDocs").val("Save");
                                    $("#savesavePoliciesFormsDocs").prop("disabled", false);
                                    $("#errorMsgDoc").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsgDoc").html(err);
                                    }
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                $("#save").val("Save");
                                $("#save").prop("disabled", false);
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                                self.hideLoader();
                            });
                }
            },

            initialConditions() {
                $("#view").hide();
                $("#edit").show();
                $(".editDetails").hide();
                $(".viewDetails").show();
            },
            onClickViewDetails() {
                $("#view").hide();
                $("#edit").show();
                $(".editDetails").hide();
                $(".viewDetails").show();
            },
            onClickEditDetails() {
                $("#view").show();
                $("#edit").hide();
                $(".editDetails").show();
                $(".viewDetails").hide();
            },
            buttonBack() {
                self.$router.push('/backend/listerg');
            },

            removeAllFiles() {
                self.$refs.dropzone.removeAllFiles();
                self.isFileUploaded = false;
            },

            vfileSuccess: function (file, response) {
                self.push(response.content.media_path);
                self.isFileUploaded = true;
                if ("media_thumb_path" in response.content) {
                    self.mediaThumbnailPaths = response.content.media_thumb_path;
                } else {
                    self.mediaThumbnailPaths.push("");
                    /*console.log("No media thumb");*/
                }
                self.imageType.push(file.type);
                self.imageSize.push(file.size);
                self.imageWidth = file.width;
                self.imageHeight = file.height;
                self.imageError = '';
            },

            removedSelectedFile(file, xhr, error) {
                if (self.imagePath.length <= 0) {
                    self.isFileUploaded = false;
                }
                var filePath = JSON.parse(file.xhr.response);
                //console.log(file);
                if ("media_thumb_path" in filePath.content) {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, filePath.content.media_thumb_path);
                } else {
                    //self.mediaThumbnailPaths.pop(filePath.content.media_thumb_path);
                    self.removeFileFromServer(filePath.content.media_path, "");
                }
                for (var i = self.imagePath.length - 1; i >= 0; i--) {
                    if (self.imagePath[i] === filePath.content.media_path) {
                        self.imagePath.splice(i, 1);
                        self.imageType.splice(i, 1);
                        self.imageSize.splice(i, 1);
                        self.imageHeight = 0;
                        self.imageWidth = 0;
                    }
                }
            },
            removeFileFromServer: function (filePath, thumbnailPath) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        filePath: filePath,
                        thumbnailPath: thumbnailPath
                    }
                };
                HTTP.delete('removemedia', config)
                        .then(function (response) {
                            /*console.log("File removed successfully");*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            vduplicateFile: function (file) { // Todo: Understand functionality. Not Working till date.
                /*console.log("Duplicate file" + file.name);*/
            },

            changedValue: function (value) {
                //console.log(value);
            },

            loadLocationsAdd(loading, search, vm) {
                search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                        .then(function (response) {
                            self.locationArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadLocations() {
                HTTP.post("/getlocation")
                        .then(function (response) {
                            self.locationArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValueLocation: function () {
                self.locationError = "";
            },
            onSearchLocation(search, loading) {
                if (search.length > 2) {
                    if (typeof (loading) != "undefined") {loading(true);}
                    this.loadLocationsAdd(loading, search, this);
                }
            },

            // loadRole() {
            //     var config = {
            //         headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
            //     };
            //     HTTP.post("getroles", '', config)
            //             .then(function (response) {
            //                 self.roleArr = [];
            //                 $.each(response.data.content, function (i) {
            //                     self.roleArr.push(response.data.content[i]);
            //                 });
            //             })
            //             .catch(function (err) {
            //                 if (err.response.status == 0) {
            //                     self.error = "Remote server can not be reachable";
            //                 } else {
            //                     //redirect to login page if user not authenticated
            //                     if (err.response.status == 401) {
            //                         //clear previous data
            //                         localStorage.removeItem("user_obj");
            //                         localStorage.removeItem("api_token");
            //                         self.$router.push("/login");
            //                         //EventBus.$emit("logged-in", true, "", "");
            //                     }
            //                 }
            //             });
            // },
            changedValueRole() {
                self.roleError = '';
            },

            checkForm: function () {
                var checked = true;
                if (self.locationId.length === 0) {
                    self.locationError = "State Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.hrId) {
                    self.roleError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                // if (self.contactNumber) {
                //     if (/^[0-9- ,-]*$/.test(self.contactNumber) == false) {
                //         self.contactNumberError = 'Please Enter Valid Contact Number';
                //         if (checked) {
                //             checked = false;
                //         }
                //     }
                // }
                // if (self.contactEmail && !self.validEmail(self.contactEmail)) {
                //     self.contactEmailError = 'Please Enter Valid Email';
                //     if (checked) {
                //         checked = false;
                //     }
                // }
                // if (self.redirectionLink != '' && !self.validUrl(self.redirectionLink)) {
                //     self.redirectionLinkError = 'Please Enter Valid URL';
                //     if (checked) {
                //         checked = false;
                //     }
                // }
                if (self.isFileUploaded == false) {
                    self.imageError = "Please Upload Image";
                    if (checked) {
                        checked = false;
                    }
                }

                return checked;
            },
            validUrl: function (url) {
                var re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                return re.test(url);
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            loadPoliciesAndForms() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[3],
                };
                self.showLoader();
                HTTP.post("geterg/" + segments[3], data, config)
                        .then(function (response) {
                            // self.locationId = {
                            //     value: response.data.content[0].location_id,
                            //     text: response.data.content[0].location_name,
                            // };
                            self.locationId = [];
                            for (var i = 0; i < response.data.content[0].location.length; i++) {
                                self.locationId.push({'text': response.data.content[0].location[i].name, 'value': response.data.content[0].location[i].id});
                            }

                            self.hrId = {
                                id: response.data.content[0].hr_id,
                                name: response.data.content[0].hr_name,
                                role: "HR",
                            };
                            self.hrDisplayName = response.data.content[0].hr_name;
                            self.title = response.data.content[0].title;
                            self.imagePath.push(response.data.content[0].image_path);
                            self.description = response.data.content[0].description;
                            self.imageDisplayWhileView = self.imagePath[0];
                            if (self.imagePath[0] != '') {
                                self.isFileUploaded = true;
                                self.imageSize.push(response.data.content[0].image_size);
                                self.imageWidth = 1200;
                                self.imageHeight = 450;
                                self.uploadManually();
                                //self.imagePath = '';
                            }
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },

            uploadManually(file) {
                if (self.imagePath.length > 0) {
                    var file_name = self.getFileName(self.imagePath[0]);
                    let file_type = self.getFileType(file_name);
                    let url = self.imagePath[0];
                    let file_size = self.imageSize[0];
                    /*console.log("File Name : " + file_name + " , File Type : " + file_type + " , URL : " + url + " , File Size : " + file_size);*/
                    let file_data = {size: file_size, fileid: file_name, name: file_name, type: file_type};
                    self.$refs.dropzone.manuallyAddFile(file_data, url);
                    /*
                     self.truckFormData.uploadedFiles.push(file_name);*/
                }

            },

            getFileName: function (file) {
                var src = file.split('/');
                var file_name = src[src.length - 1];
                return file_name;
            },
            getFileType: function (file_name) {
                var type = file_name.split('.');
                var file_type = type[type.length - 1];
                return 'image/' + file_type;
            },

            addUpdatePoliciesForms(flag) {
                //console.log("in save");
                /*console.log("Befor form check");*/
                var chk = self.checkForm();
                /*console.log(self.locationError);*/
                if (chk) {
                    //console.log("in if consition");
                    /*console.log("form check success");*/
                    var path = window.location.pathname;
                    var segments = path.split("/");
                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                    };
                    var locationsId = '';
                    for (var i = 0; i < self.locationId.length; i++) {
                        locationsId += (self.locationId[i].value) + ',';
                    }
                    locationsId = locationsId.replace(/,\s*$/, "");

                    if (segments[2] == 'viewupdatesurves') {
                        if (segments[3]) {
                            var data = {
                                hrId: self.hr_id.id,
                                locationId: locationsId,
                                title: self.title,
                                redirectionLink: self.redirectionLink,
                                description: self.description,
                                mediaPath: self.imagePath[0],
                                mediaType: self.imageType[0],
                                mediaSize: self.imageSize[0],
                                id: segments[3],
                            };
                            $("#addBenifitBtn").val("Updating ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            // $("#addAndContinueCaseBtn").prop('disabled',true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueBenifitBtn").val("Saving ...");
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            } else {
                                $("#addBenifitBtn").val("Saving ...");
                                $("#addBenifitBtn").prop("disabled", true);
                                $("#addAndContinueBenifitBtn").prop("disabled", true);
                                $("#CancelBenifit").prop("disabled", true);
                            }
                        }
                    } else {
                        var data = {
                            hrId: self.hrId.id,
                            locationId: locationsId,
                            title: self.title,
                            redirectionLink: self.redirectionLink,
                            description: self.description,
                            mediaPath: self.imagePath[0],
                            mediaType: self.imageType[0],
                            mediaSize: self.imageSize[0],
                        };
                        if (flag == "Save and Continue") {
                            $("#addAndContinueBenifitBtn").val("Saving ...");
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        } else {
                            $("#addBenifitBtn").val("Saving ...");
                            $("#addBenifitBtn").prop("disabled", true);
                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                            $("#CancelBenifit").prop("disabled", true);
                        }
                    }
                    self.showLoader();
                    HTTP.post("addupdatesurvey", data, config)
                            .then(function (response) {
                                self.removeAllFiles();
                                if (segments[2] == 'viewupdatesurves') {
                                    if (segments[3]) {
                                        //console.log(segments[3]);
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                    }
                                }

                                if (response.data.status == "success") {
                                    // self.$router.push('/task/list');
                                    $("#errorMsg").html(response.data.content);
                                    $(".alert-danger").removeClass("hide");
                                    $(".alert-danger").addClass("show");
                                    if (flag == "Save and Continue") {
//                                $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").addClass("show");
                                        self.locationId = '';
                                        self.locationArr = [];
                                        self.hrId = '';
                                        self.hr_managerArr = [];
                                        self.title = '';
                                        self.redirectionLink = '';
                                        self.description = '';
                                        self.loadLocationsAdd();
                                        self.getHrAndManagers();
                                        self.loadLocations();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.onClickViewDetails();
                                        }, 3000);
                                    } else {
                                        self.loadPoliciesAndForms();
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                            self.onClickViewDetails();
                                        }, 3000);
                                    }
                                } else {
                                    $("#alertError").show();
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                    }
                                    setTimeout(function () {
                                        $(".alert-danger").removeClass("show");
                                        $(".alert-danger").addClass("hide");
                                    }, 5000);
                                }
                                self.hideLoader();
                            })
                            .catch(function (err) {
                                self.removeAllFiles();
                                if (segments[2] == 'viewupdatesurves') {
                                    if (segments[3]) {
                                        $("#addBenifitBtn").val("Update");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").val("Save and Continue");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            $(".alert-success").removeClass("hide");
                                            $(".alert-success").addClass("show");
                                            self.removeAllFiles();
                                            self.locationId = '';
                                            self.locationArr = [];
                                            self.hrId = '';
                                            self.hr_managerArr = [];
                                            self.title = '';
                                            self.redirectionLink = '';
                                            self.description = '';
                                            self.loadLocationsAdd();
                                            self.getHrAndManagers();
                                            self.loadLocations();
                                            $("#status option[value='']").attr('selected', true);
                                            $("#type option[value='']").attr('selected', true);

                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addBenifitBtn").val("Save");
                                            $("#addBenifitBtn").prop("disabled", false);
                                            $("#addAndContinueBenifitBtn").prop("disabled", true);
                                            $("#CancelBenifit").prop("disabled", false);
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(err.response.data.message);
                                            $(".alert-danger").removeClass("hide");
                                            $(".alert-danger").addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").removeClass("show");
                                                $(".alert-danger").addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").val("Save and Continue");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        $(".alert-success").removeClass("hide");
                                        $(".alert-success").addClass("show");
                                        self.removeAllFiles();
                                        self.locationId = '';
                                        self.locationArr = [];
                                        self.hrId = '';
                                        self.hr_managerArr = [];
                                        self.title = '';
                                        self.redirectionLink = '';
                                        self.description = '';
                                        self.loadLocationsAdd();
                                        self.getHrAndManagers();
                                        self.loadLocations();

                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addBenifitBtn").val("Save");
                                        $("#addBenifitBtn").prop("disabled", false);
                                        $("#addAndContinueBenifitBtn").prop("disabled", true);
                                        $("#CancelBenifit").prop("disabled", false);
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(err.response.data.message);
                                        $(".alert-danger").removeClass("hide");
                                        $(".alert-danger").addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").removeClass("show");
                                            $(".alert-danger").addClass("hide");
                                        }, 5000);
                                    }
                                }
                                self.hideLoader();
                            });
                }

                //
            },
            progressOfUload(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploaded = true;
                    self.imageError = "";
                } else {
                    self.fileUploaded = false;
                }
            },
            progressOfUloadImg(totaluploadprogress, totalBytes, totalBytesSent) {
                if (totaluploadprogress == 100) {
                    self.fileUploadedImg = true;
                    self.imageError = "";
                } else {
                    self.fileUploadedImg = false;
                }
            },
        }
    }
</script>

<style>
    .disabled {
        pointer-events:none;
        color: #bfcbd9;
        cursor: not-allowed;
        background-image: none;
        background-color: #eef1f6;
        border-color: #d1dbe5;
    }
</style>



// WEBPACK FOOTER //
// src/components/backend/ERGs/ViewUpdateERG.vue